import { ActionTypesFactory } from '../../../../utils/utils';

export const CreateIMCActionTypes = ActionTypesFactory('createimc', 'Create_imc');
export const CreateForgotPasswordActionTypes = ActionTypesFactory('users', 'Create_forgotpassword');
export const getPaymentsDetailsActionTypes = ActionTypesFactory('payments', 'Details_Payments');